<template>
    <v-dialog max-width="450" persistent v-model="dialog">
        <v-card v-if="showConfirmationDialog">
            <v-card-title class="headline">Confirmation</v-card-title>
            <v-card-text>
                <v-card>
                    <v-card-text>
                        <p>{{ $t('msg.score_generated_text_1') }}</p>
                        <p>{{ $t('msg.score_generated_text_2') }}</p>
                        <v-card-actions>
                            <v-btn class="primary" @click="destroy" >{{ $t('cancel') }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn class="primary" @click="hideConfirmationDialog">{{ $t('confirm') }}</v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-card-text>   
        </v-card>
        <v-card v-else>
            <v-card-title class="headline">{{ $t('msg.edit_customer_info') }}</v-card-title>
<!--            <div class="notes"><b style="color: red">*</b> {{ $t('msg.asterisk_remark') }}</div>-->
            <v-card-text>
                <ValidationObserver ref="observer" v-slot="{failedRules, failed ,passes}">
                    <form>

                      <ValidationProvider vid="applicationNumber" name="applicationNumber"
                                           :rules="{required: false, regex:/^[a-zA-Z0-9]+$/ , min:3, max:10 }" ref="observerEditApplicationNumber"
                                           v-slot="{errors, failedRules}">
                        <v-text-field
                            :error-messages="$translatedErrorMessages(failedRules,'applicationNumber')"
                            :label="$t('lbl.application_number')"
                            @input="customer.applicationNumber = customer.applicationNumber.toUpperCase()"
                            v-model="customer.applicationNumber">
                        </v-text-field>
                      </ValidationProvider>

                      <v-skeleton-loader
                          :loading="loading"
                          transition="scale-transition"
                          type="list-item-two-line">
                        <v-select :error-messages="$translatedErrorMessages(failedRules,'branch')"
                                  :items="dropdown.branch"
                                  item-text="text"
                                  item-value="value"
                                  :label="$t('lbl.branch')"
                                  v-model="customer.branchNameCode"
                        ></v-select>
                      </v-skeleton-loader>

                        <v-skeleton-loader
                                :loading="loading"
                                transition="scale-transition"
                                type="list-item-two-line">
                            <v-select :error-messages="$translatedErrorMessages(failedRules,'businessCategory')"
                                      :items="dropdown.businessCategories"
                                      item-text="text"
                                      item-value="value"
                                      :label="$t('lbl.business_category')"
                                      v-model="customer.businessCategory"
                            ></v-select>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{required : false}" name="product"
                                                v-slot="{ errors, failedRules }">
                                <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'product')"
                                                :items="$parent.filters.scheme"
                                                item-text="label"
                                                item-value="code"
                                                :label="$t('lbl.product_applied')"
                                                @change="onProductChanged"
                                                v-model="customer.productApplied"
                                ></v-autocomplete>
                            </ValidationProvider>
                        </v-skeleton-loader>

<!--                      <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{required : false}" name="facility"
                                                v-slot="{ errors, failedRules }">
                                <v-select :error-messages="$translatedErrorMessages(failedRules,'facility')"
                                    :items="dropdown.facilities"
                                    :menu-props="{ maxHeight: '400' }"
                                    :label="$t('lbl.facilities')"
                                    multiple
                                    v-model="customer.facilitiesApplied"
                                ></v-select>
                            </ValidationProvider>
                        </v-skeleton-loader>-->

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider
                                    :rules="{ required: false, currency_min: selectedProduct.validation.minAmount, currency_max : selectedProduct.validation.maxAmount}"
                                    v-slot="{errors, failedRules}">
                                <v-text-field
                                        :error-messages="$translatedErrorMessages(failedRules,'financingAmount', [selectedProduct.validation.minAmount, selectedProduct.validation.maxAmount])"
                                        :label="$t('lbl.financing_amount_applied')"
                                        prefix="RM"
                                        clearable
                                        v-model="customer.loanAmount"
                                        @input="formatCurrency1"
                                >
                                </v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

<!--                      <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                        <ValidationProvider>
                          <v-text-field type="text" id="currency-input" v-model="amount" @input="formatCurrency" >
                          </v-text-field>
                          <p>Formatted Currency: {{ result }}</p>
                        </ValidationProvider>
                      </v-skeleton-loader>-->

                      <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider
                                    :rules="{ required: false, numeric: true, min_value: selectedProduct.validation.minTenure, max_value : selectedProduct.validation.maxTenure}"
                                    v-slot="{errors, failedRules}">
                                <v-text-field
                                        :error-messages="$translatedErrorMessages(failedRules,'tenureApplied', [selectedProduct.validation.minTenure, selectedProduct.validation.maxTenure])"
                                        :label="$t('lbl.financing_tenure_applied')"
                                        suffix="Months"
                                        v-model="customer.tenureApplied">

                                </v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <div>
                            <div v-show="failed">
                                <p style="color:red" >{{ $t('msg.failed_action') }}</p>
                            </div>
                            <div v-show="saveError">
                              <p style="color:red" >{{ $t('msg.failed_action') }}</p>
                            </div>
                            <div v-show="serverError">
                                <p style="color:red" >{{ $t('error.server') }}</p>
                            </div>
                            <div v-show="informationTampering">
                                <p style="color:red" >{{ $t('error.information_tampering') }}</p>
                            </div>
                        </div>
                        <v-card-actions align="right">
                            <v-spacer></v-spacer>
                            <v-skeleton-loader class="mr-3" :loading="loading||sending" transition="scale-transition" type="button">
                                <v-btn @click="destroy" color="primary">{{ $t('cancel') }}</v-btn>
                            </v-skeleton-loader>
                            <v-skeleton-loader :loading="loading||sending" transition="scale-transition" type="button">
                                <v-btn @click="passes(saveCustomer)" color="primary" dark>{{ $t('save') }}
                                </v-btn>
                            </v-skeleton-loader>
                        </v-card-actions>
                    </form>
                </ValidationObserver>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

import { dataServices } from '@/services';

export default {
        name: 'CustomerMaintenance',
        components: {
            ValidationProvider,
            ValidationObserver
        },
        data() {
            return {
                loading: false,
                dialog: false,
                menu: false,
                customer: {
                  months: 0,
                  years: 0,
                  loanAmount: 0
                },
                dropdown: {},
                branches:[],
                date: new Date().toISOString().substr(0, 10),
                editedCommencementDate:'',
                editBusinessCategoryDropdownData: [],
                validation: false,
                selectedProduct: {
                    validation: {
                        minAmount: 1,
                        maxAmount: 999999999,
                        minTenure: 1,
                        maxTenure: 240
                    }
                },
                malaysianOwnedItems: [
                    {text: 'Yes', value: 'Yes'},
                    {text: 'No', value: 'No'}
                ],
                errors: [],
                showConfirmationDialog: false,
                failed: false,
                serverError: false,
                saveError: false,
                informationTampering: false,
                sending: false,
                amount: 0,
                result: '',            }
        },
        methods: {
            init(customer, validation) {
                this.loading = true
                this.customer = Object.assign({}, customer)
                this.formatCurrency1()
                this.validation = validation
                if (this.customer.gfiScoreGenerationCount === null || (this.customer.gfiScoreGenerationCount > 0 && !this.customer.hasGfiScore) ){
                    this.showConfirmationDialog = false
                }else if(this.customer.gfiScoreGenerationCount === 1) {
                    this.showConfirmationDialog = true
                }
                this.initDropdown()
                this.dialog = true

              if(this.customer.productApplied) {
                let productValidation = this.$parent.filters.scheme.filter(f => f.code === this.customer.productApplied)[0].validation
                if(productValidation)
                  this.selectedProduct.validation=productValidation
              }
            },
            initDropdown: function () {
                dataServices.getUserDropDowns(this.$parent.userType.toUpperCase()).then(response => {
                    this.dropdown = response
                    this.branches = response.branch
                    this.loading = false
                })
            },
            uppercase () {
              if(this.customer.applicationNumber)
                this.customer.applicationNumber = this.customer.applicationNumber.toUpperCase()
            },
            saveCustomer() {
              this.sending=true
              this.serverError = false
              this.informationTampering = false
              if(this.customer.loanAmount)
                this.customer.loanAmount = String(this.customer.loanAmount).replace(/,/g, '')
              dataServices.saveCustomer(this.customer).then(response => {
                this.sending=false
                if (response && response.length===0) {
                  this.$parent.renderMessage('Successfully updated customer information.')
                  this.dialog = false
                } else {
                  response.forEach(e => {
                    if(e.field==='applicationNumber' && e.rule==='duplicate'){
                      this.$refs.observerEditApplicationNumber.applyResult({
                        errors: ['error'],
                        failedRules: ['duplicate']
                      });
                    }
                    if(e.field==='assessment' && e.rule==='duplicate'){
                      this.informationTampering=true
                    }
                    if(e.field==='businessRegistrationNumber' && e.rule==='duplicate'){
                      this.informationTampering=true
                    }
                    if(e.field==='idNumber' && e.rule==='duplicate'){
                      this.informationTampering=true
                    }
                  })
                }
              }).catch(error => {
                this.sending=false
                this.serverError = true
                console.log('Error' + error)
              })
            },
            hideConfirmationDialog() {
                this.showConfirmationDialog = false
            },
            destroy() {
                this.dialog = false
                this.serverError = false
                this.saveError = false
                this.informationTampering = false
            },
            onProductChanged() {
               let productValidation = this.$parent.filters.scheme.filter(f => f.code === this.customer.productApplied)[0].validation
               console.log(productValidation)
               if(productValidation)
                 this.selectedProduct.validation=productValidation
            },
          formatCurrency1() {
            if (this.customer.loanAmount) {
              console.log('aaa')
              let decimalAmount;
              let temp = JSON.parse(JSON.stringify(this.customer)).loanAmount;
              if(temp.toString().search(/[^0-9]/g) >= 0){
                temp = temp.toString().replace(/[^0-9]/g, '')
                decimalAmount = temp/100;
              }else {
                decimalAmount = (temp * 100)/100
              }

              const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'MYR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
              this.$nextTick( () => {
                this.customer.loanAmount = formatter.format(decimalAmount).replace("MYR","").replace("RM","").trim();
              })
            }
          }
        },
        computed: {
            isLoanOfficer: function () {
                return this.$store.state.home.user.roles.includes('ROLE_LOAN_OFFICER')
            }
        },
        watch: {
            'customer.commencementDate': function () {
                if (this.customer.commencementDate) {
                    const [year, month, day] = this.customer.commencementDate.substr(0, 10).split('-')
                    this.editedCommencementDate = `${day}-${month}-${year}`
                } else
                    this.editedCommencementDate = ''
            },
            editedCommencementDate: function (newCommencementDate) {
                if (!newCommencementDate) {
                    this.customer.commencementDate = null
                }
            }
        },
    }
</script>

<style>
    .requiredSticker label::after {
        content: "*";
        color: red;
    }
    .notes {
      padding-left: 27px;
      margin-top: -15px;
      font-size: 12px;
      color: grey;
    }
    .uppercase input {
      text-transform: uppercase;
    }
    .msg-error {
      font-size: 12px;
      font-family: 'Ubuntu', sans-serif;
      color: #a70f1c;
      line-height: 1;
      margin-top: -27px !important;
      padding-left: 13px;
    }
    .tenure {
      margin-bottom: -30px !important;
      margin-top: -10px !important;
      font-size: 12px;
    }
</style>
